import React, { useState } from "react"
//import anzyz_logo from '../../images/anzyzlogo-184x161.png';
import anzyz_logo from "../../images/logo-anzyz.png"
import anzyz from "../../images/anzyz.png"
//import anzyz_legal_logo from '../../images/anzyz_legal_logo.png';
//import anzyz_legal_logo from '../../images/logo_legal_anzyz.png';
import SideItem from "./SideItem"
import SideLogoutButton from "./SideLogoutButton"
import { MultiBaseDropdown } from "../../components"
import { useSelector } from "react-redux"

const SideMenu = () => {
	const anzyz_legal_logo = window._env_.REACT_APP_DASHBOARD_LOGO || anzyz_logo
	/* ******************* REACT STATES ******************* */
	const [activeMenu, setActiveMenu] = useState("")
	/* ******************* END REACT STATES ******************* */

	const multiBaseList = useSelector((state) => state.multiBase.multiBaseList)

	return (
		<div className="list-group aside-width border-right col-md-2 side-menu">
			<div className="list-group-item not-underlined text-dark border-0 pb-3">
				<div className="w-100 d-flex py-2 px-3">
					<img src={anzyz_legal_logo} width="100%" height="auto" alt="Web logo" />
				</div>
				<div className="w-100 d-flex justify-flex-start mt-2 px-3 pb-3">
					<div className="hide">
						<a className="text-dark not-underlined h1 mr-2" href="#!">
							<i className="bi bi-arrow-left-circle text-secondary" style={{ fontSize: "25px" }}></i>
						</a>
					</div>
					{/* <div>
                        <p className="h6 mb-0">CLIENT CASE</p>
                        <p className="h6">{ window._env_.REACT_APP_CLIENT_ID }</p>
                    </div> */}
				</div>

				{multiBaseList.length <= 1 ? (
					<div>
						<p className="h6 mb-0">CLIENT CASE</p>
						<p className="h7">{multiBaseList[0]?.friendly_name}</p>
					</div>
				) : (
					<MultiBaseDropdown />
				)}
			</div>

			<SideItem
				title="Search"
				description="Find documents, based on text or concepts."
				link="/search"
				activeMenu={activeMenu}
				setActiveMenu={setActiveMenu}
			/>
			<SideItem
				title="Build concepts"
				description="Aid your searching by creating search concepts to ignore and include search terms."
				link="/build-concept"
				activeMenu={activeMenu}
				setActiveMenu={setActiveMenu}
			/>
			<SideItem
				title="Create timeline"
				description="Charting a timeline of events can help you find elusive connections."
				link="/create-timeline"
				activeMenu={activeMenu}
				setActiveMenu={setActiveMenu}
			/>
			<SideItem
				title="View documents"
				description="Review documents tagged to concepts."
				link="/view-documents"
				activeMenu={activeMenu}
				setActiveMenu={setActiveMenu}
			/>
			{/* <SideItem
                title="FAQ"
                description="Find the answers for the most frequently asked questions."
                link="/faq"
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
            /> */}

			<SideLogoutButton link="/logout" />

			<div className="w-100 d-flex justify-content-center mb-5">
				<small>Version 1.6.26.4</small>
			</div>
		</div>
	)
}

export default SideMenu
